import Immutable from "immutable";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import {
  deleteArticle,
  deleteImage,
  edit,
  get,
} from "../../../actions/medium/article";
import { showConfirm } from "../../../actions/message";
import ArticleForm from "../../../components/forms/ArticleForm";
import EditorInput from "../../../components/inputs/EditorInput";
import Thumnail from "../../../components/inputs/Thumnail";
import ChangeEditLang from "../../../components/util/ChangeEditLang";
import { Link } from "../../../components/util/Clickable";
import { EndPoints } from "../../../constants/endpoints";
import { Path } from "../../../constants/path";
import { Formatter } from "../../../utils/formatter";
import { Notification } from "../../../utils/notification";

declare var UIkit;

class EditArticleScreen extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      article: null,
      editing: {},
      loading: false,
      description: "",
      thumnail_url: null,
      content: {},
    };
  }

  componentWillMount = () => {
    this.props.actions
      .get(this.props.match.params.articleId)
      .then(({ value, action }) => {
        if (value.status < 300) {
          const data = Formatter.mergeDesc(
            value.data,
            value.data.article_descs,
            this.props.language.edit,
          );
          this.setState({
            article: value.data,
            editing: data,
            description: data.description,
            thumnail_url: data.thumnail_url,
            content:
              value.data.publishes && value.data.publishes.length > 0
                ? value.data.publishes[0]
                : {},
          });
        }
      })
      .catch((error) => console.log(error));
  };

  onChangeLang = (lang) => {
    const editing = Formatter.mergeDesc(
      this.state.article,
      this.state.article.article_descs,
      lang,
    );
    this.setState({
      editing: editing,
      description: editing.description,
    });
  };

  onDescChange = (description) => {
    this.setState(
      Immutable.fromJS(this.state)
        .updateIn(["description"], (v) => description)
        .toJS(),
    );
  };

  onEdit = (values) => {
    delete values.publishes;
    const param = Object.assign({}, values, {
      description: this.state.description,
    });
    return this.props.actions.edit(this.state.article.id, param);
  };

  onEdited = (data) => {
    Notification.success("更新しました");
    this.setState({
      article: data,
    });
  };

  onDelete = () => {
    this.props.actions.showConfirm(
      "本当に削除しますか？",
      null,
      (confirmed) => {
        if (!confirmed) {
          return;
        }
        this.props.actions
          .deleteArticle(this.state.article.id)
          .then(({ value, status }) => {
            Notification.success("削除しました");
            this.props.history.push(Path.medium.articles.url);
          })
          .catch((error) => console.log(error));
      },
    );
  };

  onUploaded = (data) => {
    this.setState(
      Immutable.fromJS(this.state)
        .updateIn(["thumnail_url"], (v) => data.thumnail_url)
        .toJS(),
    );
    Notification.success("更新しました");
  };

  onUploadError = () => {
    Notification.error("更新に失敗しました");
  };

  onDeleteImage = () => {
    this.setState(
      Immutable.fromJS(this.state)
        .updateIn(["thumnail_url"], (v) => null)
        .toJS(),
    );
    this.props.actions
      .deleteImage(this.state.article.id)
      .then(({ value, action }) => {
        if (value.status < 300) {
          Notification.success("削除しました");
        }
      })
      .catch((error) => console.log(error));
  };

  renderEditor = () => {
    return (
      <div className="" data-uk-grid>
        <div className="uk-width-large@s">
          <h2>記事情報</h2>
          <div className="uk-margin">
            <ArticleForm
              editing={true}
              initialValues={this.state.editing}
              onSubmit={this.onEdit}
              onSuccess={this.onEdited}
            />
          </div>
          <hr />
          <div className="uk-margin uk-text-center">
            <Link
              className="uk-button uk-button-danger"
              onClick={this.onDelete}
            >
              削除
            </Link>
          </div>
          <h2>サムネイル</h2>
          <div className="uk-margin">
            <Thumnail
              url={EndPoints.mediumArticles(this.state.article.id, "image")}
              src={this.state.thumnail_url}
              onSuccess={this.onUploaded}
              onDelete={this.onDeleteImage}
              keyExtractor={(value) => value.thumnail_url}
            />
          </div>
        </div>

        <div className="uk-width-expand">
          <h2>本文</h2>
          <div className="uk-margin">
            <EditorInput
              uploadUrl={EndPoints.mediumImages()}
              onChange={this.onDescChange}
              value={this.state.description}
            />
          </div>
        </div>
      </div>
    );
  };

  render = () => {
    return (
      <div>
        <div className="uk-margin-small" data-uk-grid>
          <div className="uk-width-expand">
            <h1>記事の編集</h1>
          </div>
          <div className="uk-width-medium@s uk-width-1-1 uk-text-right">
            <ChangeEditLang onChange={this.onChangeLang} />
          </div>
        </div>

        <div className="uk-margin-large">
          {(() => {
            if (!this.state.article) {
              return (
                <div className="uk-text-center">
                  <span data-uk-spinner="ratio: 3"></span>
                </div>
              );
            } else {
              return this.renderEditor();
            }
          })()}
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    language: state.language,
    medium: state.auth.data ? state.auth.data : {},
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      get: (param) => dispatch(get(param)),
      edit: (...param) => dispatch(edit(...param)),
      deleteArticle: (...param) => dispatch(deleteArticle(...param)),
      deleteImage: (...param) => dispatch(deleteImage(...param)),
      showConfirm: (...param) => dispatch(showConfirm(...param)),
    },
    dispatch,
  ),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EditArticleScreen),
);
